import React from "react";
import { Table, Tooltip } from "antd";
import type { ColumnsType } from "antd/es/table";
import { TFileManagerMaster } from "../../../types";
import DateUtils from "../../../utils/date";
import { TContext } from "../../../types/config";

// Props for our new component
interface UploadListProps {
  data: TFileManagerMaster[];
  loading?: boolean;
  context?: TContext;
}

// --- 4. The React Component ---
/**
 * A compact, dashboard-friendly list to display recent file uploads.
 */
export const RecentUploadsList: React.FC<UploadListProps> = ({
  data,
  loading,
  context,
}) => {
  const columns: ColumnsType<TFileManagerMaster> = [
    {
      title: "File Name",
      dataIndex: "uploadFileName",
      key: "uploadFileName",
      render: (text, record) => (
        <>
          <Tooltip title={text}>
            <a
              href={record?.documentModel?.path}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                maxWidth: "320px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                verticalAlign: "middle",
              }}
            >
              {text}
            </a>
          </Tooltip>
          <br />
          <small>
            By {record.createdByName} on{" "}
            {DateUtils.format(
              record.createdOn,
              context?.user?.dateFormat,
              true
            )}
          </small>
        </>
      ),
    },
    // {
    //   title: "Uploaded By",
    //   dataIndex: "createdByName",
    //   key: "createdByName",
    // },
    // {
    //   title: "Date",
    //   dataIndex: "createdOn",
    //   key: "createdOn",
    //   render: (date) => ,
    // },
    {
      title: "Records",
      dataIndex: "recordCount",
      key: "recordCount",
      align: "right",
      width: 100,
      render: (count) => <h2>{count}</h2>,
    },
  ];

  return (
    <Table
      style={{ height: "max-content" }}
      sticky
      rowKey="id"
      size="small"
      loading={loading}
      dataSource={data}
      columns={columns}
      pagination={false}
      scroll={{ x: true }}
    />
  );
};
